<template>
  <div>
    <div
      class="main-header"
      :class="{ 'improve-grades-header': improveGradesHeader }"
    >
      <div
        :class="`bg-yellow logo-box-container ${hideHeader ? 'isInStep' : ''}`"
        :style="{ height: hideHeader ? '162px' : '' }"
      >
        <img src="/images/simbolo.png" class="left-simbol" alt="" />
        <img src="/images/sombra-1.png" class="middle-simbol" alt="" />
        <img src="/images/sombra-2.png" class="last-simbol" alt="" />
        <div
          v-if="hideHeader"
          class="d-md-flex container p-0 header-steps flex-lg-row flex-md-column justify-content-lg-between"
          style="z-index: 10"
        >
          <div class="logo d-lg-flex d-md-none d-none">
            <a href="https://www.preupdv.cl/">
              <img src="/images/logo_header_pdv_cuadrado.png" alt="Logo" />
            </a>
          </div>
          <div
            class="d-flex d-md-flex d-lg-none justify-content-between logo-mobile-container flex-row"
          >
            <div class="logo">
              <a href="https://www.preupdv.cl/">
                <img src="/images/logo_header_pdv_cuadrado.png" alt="Logo" />
              </a>
            </div>
            <div
              class="d-lg-none d-flex link-tel-container justify-content-center align-items-center"
            >
              <a
                href="tel:+56229949850"
                class="d-flex tel-link"
                style="color: #000"
              >
                +56 2 2994 9850</a
              >
            </div>
          </div>
          <div class="d-flex flex-column text-header-container pl-3">
            <p class="recomend-course-header">
              Sigue los pasos para cotizar y elegir el programa que deseas y se
              adapte a ti
            </p>
            <!--p class="recomend-course-sub-header">Comparador de programas PDV</p-->
          </div>
          <div
            class="d-lg-flex d-none justify-content-center align-items-center w-20"
          >
            <a
              href="tel:6005002020"
              class="d-flex tel-link"
              style="color: #000"
            >
              +56 2 2994 9850</a
            >
          </div>
        </div>
        <div v-if="!hideHeader" class="container">
          <div class="row logo-box no-margingx justify-content-between">
            <div class="col-md-1 col-3 d-flex align-items-start">
              <div class="logo">
                <a href="https://www.preupdv.cl/">
                  <img src="/images/logo_header_pdv_cuadrado.png" alt="Logo" />
                </a>
              </div>
            </div>
            <div
              v-if="!improveGradesHeader"
              class="col-md-11 d-none d-md-none d-lg-flex align-items-center main-menu-header-col"
            >
              <div class="d-lg-flex w-100 justify-content-between flex-row">
                <div v-if="!hideHeader">
                  <div
                    class="d-lg-flex d-none flex-row align-items-start main-menu-header"
                  >
                    <div class="d-flex flex-column header-link-home-container">
                      <router-link
                        :to="{ name: 'Landing' }"
                        class="d-flex fs-md-16 header-link-home"
                      >
                        Home
                      </router-link>
                      <div
                        v-if="currentPage === 'Landing'"
                        class="labeler"
                      ></div>
                    </div>
                    <div class="d-flex flex-column header-link-home-container">
                      <a
                        href="https://www.preupdv.cl/"
                        target="_blank"
                        class="d-flex fs-md-16 header-link-home"
                        >Preuniversitario PDV</a
                      >
                      <div v-if="currentPage === '/pdv'" class="labeler"></div>
                    </div>
                    <div class="d-flex flex-column header-link-home-container">
                      <a
                        href="https://www.preupdv.cl/sedes"
                        target="_blank"
                        class="d-flex fs-md-16 header-link-home"
                        >Sede</a
                      >
                      <div v-if="currentPage === '/sede'" class="labeler"></div>
                    </div>
                    <div class="d-flex flex-column header-link-home-container">
                      <a
                        href="https://www.preupdv.cl/contacto"
                        target="_blank"
                        class="d-flex fs-md-16 header-link-home"
                        >Contacto</a
                      >
                      <div
                        v-if="currentPage === '/contacto'"
                        class="labeler"
                      ></div>
                    </div>
                    <div class="d-flex flex-column header-link-home-container">
                      <router-link
                        :to="{ name: 'Outlet1' }"
                        class="d-flex fs-md-16 header-link-home"
                      >
                        Outlet
                      </router-link>
                      <div
                        v-if="currentPage.contains('outlet')"
                        class="labeler"
                      ></div>
                    </div>
                  </div>
                  <div></div>
                </div>
                <div
                  v-if="!hideHeader"
                  class="d-lg-flex d-none justify-content-center align-items-center phone-header-container"
                >
                  <a
                    href="tel:+56 2 2994 9850"
                    class="d-flex tel-link"
                    style="color: #000"
                  >
                    +56 2 2994 9850</a
                  >
                </div>
              </div>
            </div>

            <div
              v-if="improveGradesHeader"
              class="d-lg-flex d-none justify-content-center align-items-center phone-header-container"
            >
              <a
                href="tel:+56 2 2994 9850"
                class="d-flex tel-link"
                style="color: #000"
              >
                +56 2 2994 9850</a
              >
            </div>

            <div
              v-if="!hideHeader"
              class="d-flex d-lg-none col-9 col-md-12 d-flex justify-content-end align-items-center flex-row"
            >
              <div
                v-if="improveGradesHeader"
                class="d-flex justify-content-center align-items-center phone-header-container"
              >
                <a
                  href="tel:6005002020"
                  class="d-flex tel-link"
                  style="color: #000"
                >
                  +56 2 2994 9850</a
                >
              </div>

              <div v-else @click="openMobileMenu" class="ham-menu">
                <div class="line"></div>
                <div class="line"></div>
                <div class="line"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="menu-mobile"
      id="menu-mobile"
      :class="{ open: mobileMenuShow }"
      v-show="mobileMenuShow"
    >
      <ul>
        <li>
          <a
            class="d-flex fs-md-16 header-link-mobile"
            @click.prevent="goTo('Landing')"
            >Home</a
          >
        </li>
        <li>
          <a
            href="https://www.preupdv.cl/"
            target="_blank"
            class="d-flex fs-md-16 header-link-mobile"
            >Preuniversitario PDV</a
          >
        </li>
        <li>
          <a
            href="https://www.preupdv.cl/sedes"
            target="_blank"
            class="d-flex fs-md-16 header-link-mobile"
            >Sede</a
          >
        </li>
        <li>
          <a
            href="https://www.preupdv.cl/contacto"
            target="_blank"
            class="d-flex fs-md-16 header-link-mobile"
            >Contacto</a
          >
        </li>
        <li>
          <a
            @click.prevent="goTo('Outlet1')"
            class="d-flex fs-md-16 header-link-mobile"
            >Outlet</a
          >
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      mobileMenuShow: false,
      currentPage: null,
      discount: null,
    };
  },
  computed: {
    backpackVisible() {
      return this.$store.state.backpackVisible;
    },

    studentsWithPrices() {
      return this.$store.state.studentsWithPrices;
    },
  },

  watch: {
    currentPage(newVal) {
      if (newVal === "Step3") {
        this.$store.dispatch("setStudentsWithPrices");
      }
    },
  },

  props: {
    showBackpack: {
      default: true,
    },
    showPromoMessage: {
      default: true,
    },
    hideHeader: {
      default: false,
    },
    improveGradesHeader: {
      default: false,
    },
  },
  mounted() {
    this.currentPage = this.$route.name;
  },
  methods: {
    goTo(slug) {
      document.body.style.overflow = "visible";
      if (slug !== "#") {
        this.$router.push({ name: slug });
      }
    },
    openMobileMenu() {
      if (!this.mobileMenuShow) {
        document.body.style.overflow = "hidden";
        this.mobileMenuShow = true;
      } else {
        document.body.style.overflow = "visible";
        this.mobileMenuShow = false;
      }
    },
  },
  // created(){
  //   this.Axios.get('/dashadmin/infogeneral').then((response) => {
  //     this.discount= response.data[0].discount;

  //   });
  // }
};
</script>

<style scoped lang="scss">
.main-header {
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 10;

  &.improve-grades-header {
    position: static;

    .logo-box-container {
      @include media-breakpoint-down(sm) {
        height: 88px !important;
      }
      height: auto;
      .logo-box .logo {
        margin-left: 15px;
        img {
          width: auto;
          height: 83px;
        }
      }
    }

    .main-menu-header-col {
      align-items: flex-start !important;
      .main-menu-header {
        padding: 46px 0 27px;
      }
    }

    .phone-header-container {
      align-items: flex-start !important;
      a {
        padding: 46px 0 27px;
      }
    }

    .left-simbol,
    .middle-simbol,
    .last-simbol {
      display: none;
    }
  }
  @include media-breakpoint-down(sm) {
    z-index: 200;
  }
  .container {
    @include media-breakpoint-down(sm) {
      padding-left: 0;
      padding-right: 0;
    }
  }
  .logo-box-container {
    // padding: 0 20px;
    height: 118px;
    display: flex;
    @media screen and (max-width: 430px) {
      height: 76px !important;
      &.isInStep {
        height: 165px !important;
      }
    }
    .logo-box {
      min-height: 95px;
      @include media-breakpoint-down(md) {
        min-height: 76px;
        height: 76px;
        flex-direction: row;
      }
      .logo {
        margin-right: 30px;
        @include media-breakpoint-down(md) {
          z-index: 100;
          margin-left: 42px;
          margin-right: 0;
        }
        img {
          position: absolute;
          top: 0;
          width: 67px;
          @include media-breakpoint-down(md) {
            width: 60px;
          }
        }
      }
    }
  }

  .promo-message {
    text-align: right;
    margin-right: 28px;
    h3 {
      font-size: 16px;
      margin-bottom: 0;
      @include font-light-regular;
      letter-spacing: 1.5px;
    }
    span {
      line-height: 21px;
      display: inline-block;
      background: #fff;
      color: #000;
      font-size: 16px;
      padding: 2px 5px;
      @include alternative-bold;
      letter-spacing: 1.2px;
    }
  }

  .btn-mobile-menu {
    position: absolute;
    top: 0;
    right: 0;
    background: #000;
    padding: 20px;
    height: 100%;
    img {
      width: 20px;
    }
  }

  .backpack-btn {
    @include media-breakpoint-down(sm) {
      margin-right: 50px;
    }
  }
}

.mobile-menu {
  background: #000;
  position: fixed;
  right: 0;
  width: 70%;
  padding: 37px 15px;
  box-shadow: -3px 5px 9px 2px #00000075;
  ul {
    padding: 0;
    margin: 0;
    li {
      list-style: none;
      text-align: right;
      margin-bottom: 28px;
      &:last-child {
        margin-bottom: 0;
      }
      a {
        color: #fff;
        text-decoration: underline;
        font-size: 13px;
        line-height: 17px;
        @include alternative-regular;
        &:hover {
          color: #fff;
        }
      }
    }
  }
}

.backpack-float-number-container {
  position: absolute;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid #000;
  background: #fff;
  left: -3px;
  top: 6px;
  .backpack-float-number {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    @include alternative-bold;
    color: #000;
  }
}
hr {
  height: 0.25rem;
  width: 25%;
  margin: 0;
  background: $black;
  border: none;
  transition: 0.3s ease-in-out;
}
.tel-link {
  @include alternative-bold;
  font-size: 20px;
  font-weight: bold;
  letter-spacing: -0.28px;
  line-height: 22px;
  text-align: right;
  @include media-breakpoint-down(sm) {
    font-size: 20px;
    line-height: 22px;
    letter-spacing: -0.3px;
  }
  &:before {
    content: url("/images/svgs/telefono.svg");
    width: 18px;
    height: 18px;
    left: 0;
    margin-right: 8px;
  }
}
.ham-menu {
  margin-right: 35px;
  height: 24px;
  width: 24px;
  padding: 6px 3px 6px 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  .line {
    &:nth-child(1) {
      margin-bottom: 2px;
    }
    &:nth-child(2) {
      margin-bottom: 2px;
    }
    width: 18px;
    height: 2px;
    background: #000;
  }
}
.menu-mobile {
  width: 0;
  height: 100vh;
  overflow: hidden;
  position: absolute;
  right: 0;
  z-index: 100;
  background: $yellow;
  transition: 0.5s all ease-in-out;
  ul {
    text-align: center;
    list-style: none;
    padding: 0;
    margin: 0;
    li {
      text-decoration: none;
      list-style: none;
      text-align: center;
      padding: 10px 0;
      justify-content: center;
      a {
        justify-content: center;
      }
    }
  }
}
.open {
  width: 100%;
  position: absolute;
  top: 76px;
  bottom: 0;
  transition: 0.5s all ease-in-out;
}
.w-20 {
  width: 20%;
}
.recomend-course-header {
  font-size: 34px;
  line-height: 40px;
  letter-spacing: -0.43px;
  text-align: left;
  opacity: 0.9;
  display: flex;
  margin-bottom: 0;
  color: #000;
  @include Gotham-Black;
  @include media-breakpoint-down(md) {
    font-size: 18px;
    letter-spacing: -0.22px;
    line-height: 20px;
    margin-left: 42px;
  }
  @include media-breakpoint-down(sm) {
    width: 312px;
  }
  @media screen and (max-width: 768px) {
    margin-left: 0;
  }
  @media screen and (max-width: 430px) {
    margin-left: 42px;
  }
  @media screen and (max-width: 320px) {
    margin-left: 20px;
    display: inline-flex;
    flex-wrap: nowrap;
    width: auto;
  }
}
.recomend-course-sub-header {
  font-size: 25px;
  letter-spacing: -0.3px;
  line-height: 50px;
  margin-bottom: 0;
  color: #000;
  @include Gotham-Book;
  @include media-breakpoint-down(md) {
    font-size: 15px;
    letter-spacing: -0.18px;
    line-height: 20px;
    opacity: 0.9;
  }
  @include media-breakpoint-down(md) {
    margin-left: 42px;
  }
  @media screen and (max-width: 768px) and (min-width: 600px) {
    margin-left: 0 !important;
  }
  @media screen and (max-width: 320px) {
    margin-left: 20px;
    display: inline-flex;
    flex-wrap: nowrap;
    width: auto;
  }
}
.header-mobile-container {
  margin-top: 20px;
  margin-bottom: 20px;
}
.header-link-home {
  color: $black;
  margin-bottom: 5px;
  &:hover {
    text-decoration: none;
    color: $black;
  }
  @include alternative-regular();
  font-size: 16px;
  letter-spacing: -0.23px;
  line-height: 22px;
}
.header-link-home-container {
  margin: 0 27.5px;
  &:first-child {
    margin-left: 35px;
    margin-right: 27.5px;
  }
}
.labeler {
  height: 5px;
  width: 100%;
  background-color: #000000;
}
.left-simbol {
  position: absolute;
  top: -33px;
  left: -190px;
  width: 297px;
  height: 239px;
  opacity: 0.5;
  @include media-breakpoint-down(sm) {
    left: -140px;
  }
}
.header-steps {
  max-width: 1270px;
  .logo {
    @include media-breakpoint-down(md) {
      img {
        position: relative;
        z-index: 100;
        height: 60px;
        width: 60px;
      }
      display: flex;
      margin-left: 42px;
    }
    @include media-breakpoint-down(sm) {
      img {
        width: 60px;
      }
    }
  }
}
.text-header-container {
  align-self: center;
  @include media-breakpoint-down(sm) {
    width: 100%;
    // justify-content: center;
    // align-items: center;
  }
}
.link-tel-container {
  display: none;
  @include media-breakpoint-down(md) {
    display: flex;
    margin-right: 33px;
  }
}
.logo-mobile-container {
  margin-bottom: 22px;
}
.middle-simbol {
  position: absolute;
  left: 42%;
  top: 0;
  width: auto;
  height: auto;
  z-index: 0;
  @include media-breakpoint-down(sm) {
    display: none;
  }
}
.last-simbol {
  position: absolute;
  right: 11%;
  top: -150px;
  width: auto;
  height: auto;
  z-index: 0;
  @include media-breakpoint-down(sm) {
    display: none;
  }
}
.header-link-mobile {
  @include alternative-regular();
  font-size: 16px;
  letter-spacing: -0.23px;
  line-height: 22px;
  color: #000;
  text-align: center;
  &:hover {
    color: #000;
  }
}
.no-margingx {
  margin-right: 0px !important;
  margin-left: 0px !important;
}
</style>
